import { Contract, utils, BigNumber } from "ethers";
import { _getProvider } from "./ethereum";
import CLAIMV3_ABI from "./abi/claimV3.abi";

function getContract(abi = CLAIMV3_ABI) {
    const provider = _getProvider();
    if (!provider) throw new Error("Unable to connect to wallet");

    const signer = provider.getSigner();
    return new Contract(process.env.REACT_APP_CLAIM_V3, abi, signer);
}

const getGasLimit = (gasEstimate) => {
    return gasEstimate.mul(BigNumber.from(15)).div(BigNumber.from(10));
}

const getGasPrice = async () => {
    const provider = _getProvider();
    if (!provider) throw new Error("Unable to connect to wallet");
    return Math.round(await provider.getGasPrice() * 1.4);
}

export const hasClaimed = async (wallet) => {
    const contract = getContract();
    return await contract.hasClaimed(wallet);
}

export const claim = async () => {
    const contract = getContract();
    var gasEstimate;
    var estimateError;
    await contract.estimateGas.claim().then(result => gasEstimate = result, error => estimateError = error);
    if (estimateError) return estimateError;
    return await contract.claim({
        gasLimit: getGasLimit(gasEstimate),
        gasPrice: await getGasPrice()
    });
}